import React from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'


export default class extends React.Component {
    render () {
        const data = {
            url: '/admin/carriers/settings/sipheaders',
            data: {
                data: [],
                metadata: []
            },
            metadata:
             [
                    {
                        'label': 'id',
                        'source': 'ATRSIPHEADERGROUPID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'SIP Header Group Name',
                        'source': 'ATRNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'New SIP header group...'
                    },
                    {
                        'label': 'Enabled',
                        'source': 'ATRSTATUS',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : true
                    },
                    {
                        label: 'View',
                        value: '/carriers/settings/sipheaders/{$id}',
                        type: 'link'
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        return (
            <Panel title = "Carrier SIP Header Groups">
                <Resource data = {data} {...this.props} addButtonValue="Add SIP Header Group" />
            </Panel>
        )
    }


}